import React, { useContext, useState, useEffect } from "react";
import CommunicationModal from "../../../Communication/CommunicationModal";
import { IconButton } from "@fluentui/react";
import { ReactQueryDevtools } from "react-query/devtools";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
} from "react-query";
import { tabDetails } from "../../helpers/initData";
import {
  checkboxStyle,
  getCurrentActiveTabName,
  getCurrentActiveTabId,
  menuPropsItems,
  options,
  searchIcon,
  searchInputStyle,
  sortingMenuPropsItems,
  checkForNumberOfFilterApplied,
} from "../../helpers/mobileUtilities";
import FilterMobileIcon from "../../../../components/SVGComponents/FilterMobileIcon";
import studylistContext from "../../../../context/studylist/StudylistContext";
import StudyListTable from "../../../../components/StyleListTable/StudyListTable";
import themeContext from "../../../../context/theme/ThemeContext";
import MobileStudyListTable from "../../../../components/StyleListTable/MobileStudyListTable";
import MobileStudyListFilters from "./MobileStudyListFilters";
import { USERTYPES } from "../../../../constants/Constants";
import MobileStudylistTabBar from "./MobileStudylistTabBar";
import MobileAssignmentFilter from "./MobileAssignmentFilter";
import AlertSuccessModal from "../../../../components/AlertSuccessModal/AlertSuccessModal";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
const queryClient = new QueryClient();

const MobileStudyListContainer = (props) => {
  const {
    setAllStudies,
    studyData,
    columns,
    allStudies,
    searchDto,
    setSearchDto,
    sortGlobal,
    setSortGlobal,
    filterInputValues,
    showFilters,
    setShowFilters,
    applyClick,
    setApplyClick,
    storefilterBadges,
    setStoreFilterBadges,
    filterBadges,
    setFilterBadges,
    roles,
    hideModal,
    showCommunicationModal,
    selectedValue,
    setSelectedValue,
    unreportedAllTabs,
    trackApplyButton,
    setTrackApplyButton,
    mobileAssignmentObject,
    fetchData,
    checkForConditionRequired,
    paginationObj,
    handleChangeSizeIndex,
  } = useContext(studylistContext);
  const { themeName } = useContext(themeContext);

  const { alertSuccessModal,hideAlertSuccessModal } = useContext(studyReportContext);

  const sortMenuProps = {
    shouldFocusOnMount: true,
    items: sortingMenuPropsItems(
      sortGlobal,
      setSortGlobal,
      props.handleDropDownClick
    ),
    styles: {
      root: {
        background: "#8080805e",
        minWidth: "115px",
        root: { background: "green" },
      },
    },
  };

  const pageObj = props.pageObj;
  // const paginationObj = props.paginationObj;
  const setDataQueryParent = props.setDataQueryParent;
  const handleRefresh = props.handleRefresh;

  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

  const togglePopup = () => {
    setIsMobileFilterOpen((prev) => !prev);
  };

  const contextMenuStyle = {
    root: {
     backgroundColor:`${themeName == "dark" || themeName == "dark-midnight"?"#212E43":'white'}`,
     borderRadius: "7px",
     minWidth:"115px",
     beak:{
      backgroundColor:`${themeName == "dark" || themeName == "dark-midnight"?"#212E43":'white'}`,
     }
    },
    calloutMain:{
      borderRadius: "7px"
    },
    rootHovered: {
      color: "white",
    }
  };

  useEffect(() => {
    const navbarStaticTop = document.getElementsByClassName("navbar-static-top")[0];
    
    if (navbarStaticTop) {
      navbarStaticTop.style.display = "none";
    }
  }, []);


  return (
    <>
      <div className="study-list-mobile-main-container">
        <div className="study-list-mobile-topbar">
        {alertSuccessModal?.show && (
              <AlertSuccessModal
                isError={alertSuccessModal.isError}
                isWarning={alertSuccessModal.isWarning}
                isSuccess={alertSuccessModal.isSuccess}
                heading={alertSuccessModal.heading}
                description={alertSuccessModal.description}
                hideModal={hideAlertSuccessModal}
                isModalOpen={alertSuccessModal?.show}
              />
            )}
          {showCommunicationModal.show && (
            <CommunicationModal
              isModalOpen={showCommunicationModal.show}
              hideModal={hideModal}
              studyParentId={showCommunicationModal.studyId}
              studylist={true}
            />
          )}
          {/* <IconButton
            iconProps={{ iconName: "sortIcon" }}
            menuProps={sortMenuProps}
            style={{ color: "#8A8886", border: "none", outline: "none" }}
          /> */}
          <div style={{width:"100%"}}>
            {/* <span className="study-list-mobile-tab-txt">
              {getCurrentActiveTabName(
                tabDetails(roles, selectedValue, themeName, unreportedAllTabs),
                selectedValue
              )}{" "}
              Studies
            </span> */}
            <MobileStudylistTabBar />
            {/* <IconButton
              // iconProps={{ iconName: "More" }}
              menuProps={menuProps}
              style={{ color: "#8A8886", border: "none", outline: "none" }}
            /> */}
          </div>
          <div style={{ position: "relative" }} onClick={() => togglePopup()}>
            <div style={{position: "absolute"}} className="filter-mobile-icon">
            <FilterMobileIcon active={trackApplyButton || searchDto.uploadDate != null} />
            </div>
           
          </div>
        </div>
        <QueryClientProvider client={queryClient}>
          <>
            {selectedValue === "study_1" &&
              checkForConditionRequired(filterInputValues?.showAllStudies) && (
                // <StudyListTable
                //   id="unreported"
                //   fetchData={fetchData}
                //   pageObj={paginationObj.unreported}
                //   sortObj={sortGlobal}
                //   handleChangeSizeIndex={handleChangeSizeIndex}
                //   setDataQueryParent={setDataQueryParent}
                //   roles={roles}
                //   refresh = {handleRefresh}
                // />
                <MobileStudyListTable
                  id="unreported"
                  fetchData={fetchData}
                  pageObj={paginationObj.unreported}
                  sortObj={sortGlobal}
                  handleChangeSizeIndex={handleChangeSizeIndex}
                  setDataQueryParent={setDataQueryParent}
                  roles={roles}
                  refresh={handleRefresh}
                />
              )}
            {selectedValue === "study_2" && (
              // <StudyListTable
              //   id="saved"
              //   fetchData={fetchData}
              //   pageObj={paginationObj.saved}
              //   sortObj={sortGlobal}
              //   handleChangeSizeIndex={handleChangeSizeIndex}
              //   setDataQueryParent={setDataQueryParent}
              //   roles={roles}
              //   refresh = {handleRefresh}
              // />

              <MobileStudyListTable
                id="saved"
                fetchData={fetchData}
                pageObj={paginationObj.saved}
                sortObj={sortGlobal}
                handleChangeSizeIndex={handleChangeSizeIndex}
                setDataQueryParent={setDataQueryParent}
                roles={roles}
                refresh={handleRefresh}
              />
            )}
            {selectedValue === "study_3" && (
              <MobileStudyListTable
                id="reported"
                fetchData={fetchData}
                pageObj={paginationObj.reported}
                sortObj={sortGlobal}
                handleChangeSizeIndex={handleChangeSizeIndex}
                setDataQueryParent={setDataQueryParent}
                roles={roles}
                refresh={handleRefresh}
              />
            )}
            {selectedValue === "study_4" && (
              <MobileStudyListTable
                id="closed"
                fetchData={fetchData}
                pageObj={paginationObj.closed}
                sortObj={sortGlobal}
                handleChangeSizeIndex={handleChangeSizeIndex}
                setDataQueryParent={setDataQueryParent}
                roles={roles}
                refresh={handleRefresh}
              />
            )}
            {selectedValue === "study_5" && (
              <MobileStudyListTable
                id="qcreview"
                fetchData={fetchData}
                pageObj={paginationObj.qcreview}
                sortObj={sortGlobal}
                handleChangeSizeIndex={handleChangeSizeIndex}
                setDataQueryParent={setDataQueryParent}
                roles={roles}
                refresh={handleRefresh}
              />
            )}
            {selectedValue === "study_6" && (
              <MobileStudyListTable
                id="qcfix"
                fetchData={fetchData}
                pageObj={paginationObj.qcfix}
                sortObj={sortGlobal}
                handleChangeSizeIndex={handleChangeSizeIndex}
                setDataQueryParent={setDataQueryParent}
                roles={roles}
                refresh={handleRefresh}
              />
            )}
            {selectedValue === "study_7" && (
              <MobileStudyListTable
                id="qcverify"
                fetchData={fetchData}
                pageObj={paginationObj.qcverify}
                sortObj={sortGlobal}
                handleChangeSizeIndex={handleChangeSizeIndex}
                setDataQueryParent={setDataQueryParent}
                roles={roles}
                refresh={handleRefresh}
              />
            )}
            {selectedValue === "study_8" && (
              <MobileStudyListTable
                id="returned"
                fetchData={fetchData}
                pageObj={paginationObj.returned}
                sortObj={sortGlobal}
                handleChangeSizeIndex={handleChangeSizeIndex}
                setDataQueryParent={setDataQueryParent}
                roles={roles}
                refresh={handleRefresh}
              />
            )}
            {selectedValue === "study_9" && (
              <MobileStudyListTable
                id="critical"
                fetchData={fetchData}
                pageObj={paginationObj.critical}
                sortObj={sortGlobal}
                handleChangeSizeIndex={handleChangeSizeIndex}
                setDataQueryParent={setDataQueryParent}
                roles={roles}
                refresh={handleRefresh}
              />
            )}
            {selectedValue === "study_10" && (
              <MobileStudyListTable
                id="library"
                fetchData={fetchData}
                pageObj={paginationObj.library}
                sortObj={sortGlobal}
                handleChangeSizeIndex={handleChangeSizeIndex}
                setDataQueryParent={setDataQueryParent}
                roles={roles}
                refresh={handleRefresh}
              />
            )}
          </>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>

        <div className={`popup ${(isMobileFilterOpen || mobileAssignmentObject.showProviderFilter) ? "open" : ""}`}>
        {mobileAssignmentObject.showProviderFilter ?
          <MobileAssignmentFilter />
        :
          <MobileStudyListFilters
            togglePopup={togglePopup}
            isMobileFilterOpen={isMobileFilterOpen}
            handleRefresh={handleRefresh}
          />}
        </div>
      </div>
    </>
  );
};

export default MobileStudyListContainer;
